import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { NAV } from "@/data/content";
import { useCopy } from "@/lib/copy";
import { Logo, NetworkGraphic } from "./Brand";
import { Swappable } from "./Media";

export const Footer = () => {
  const t = useCopy();
  const email = t("contact.details.email");
  const social = [
    { id: "brain", href: t("contact.social.brainUrl"), short: t("footer.main.linkedinBrain") },
    { id: "prasara", href: t("contact.social.prasaraUrl"), short: t("footer.main.linkedinPrasara") },
  ];
  return (
    <footer className="relative overflow-hidden bg-brand-black text-white" data-testid="site-footer">
      <Swappable src={t("footer.main.patternImage")} className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]"><NetworkGraphic className="pointer-events-none absolute -right-16 -top-10 h-72 w-auto opacity-[0.12]" /></Swappable>
      <div className="container-x relative grid gap-12 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-5">
          <Logo variant="white" className="h-24 w-auto" />
          <p className="mt-6 max-w-sm whitespace-pre-line text-sm leading-relaxed text-white/70" data-testid="footer-description">{t("footer.main.description")}</p>
        </div>
        <nav aria-label="Footer" className="md:col-span-3">
          <p className="eyebrow mb-4 text-brand-green" data-testid="footer-explore-heading">{t("footer.main.exploreHeading")}</p>
          <ul className="space-y-3">
            <li><Link to="/" className="footer-link" data-testid="footer-home-link">{t("footer.main.homeLabel")}</Link></li>
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="footer-link" data-testid={`footer-${n.id}-link`}>{t(n.key)}</Link></li>
            ))}
          </ul>
        </nav>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4 text-brand-green" data-testid="footer-contact-heading">{t("footer.main.contactHeading")}</p>
          <a href={`mailto:${email}`} className="footer-link text-sm" data-testid="footer-email-link">{email}</a>
          <address className="mt-3 whitespace-pre-line text-sm not-italic leading-relaxed text-white/70" data-testid="footer-address">{t("contact.details.address")}</address>
          <div className="mt-5 flex gap-3">
            {social.map((s) => (
              <a key={s.id} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`${s.short} on LinkedIn (opens in a new tab)`} className="inline-flex items-center gap-2 rounded-full border border-white/25 px-3 py-2 text-xs font-bold text-white hover:border-brand-green hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-green" data-testid={`footer-linkedin-${s.id}`}>
                <Linkedin className="h-4 w-4" aria-hidden="true" />{s.short}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-2 py-6 text-xs text-white/60 md:flex-row md:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {t("footer.main.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};
